<template>
  <label :class="[$style['form-input'], {[$style['form-input--error']]: meta.touched && !meta.valid }]">
    <div :class="$style['form-input__label']">
      <Icon v-if="$attrs.type === 'file'" name="Camera" />
      {{ label }}
    </div>
    <input v-model="value" v-bind="$attrs" :class="$style['form-input__input']" :placeholder="placeholder">

    <div v-if="errors.length" :class="$style['form-input__errors']">
      {{ errors[0] }}
    </div>
  </label>
</template>
<script setup lang="ts">
import { useField } from 'vee-validate'
const props = defineProps<{
  name: string,
  modelValue?: string | number | undefined,
  label?: string,
  placeholder?: string
}>()

const { value, errors, meta } = useField(props.name, undefined, { syncVModel: true })

</script>
<style  module>
.form-input {
  width: 100%;
}

.form-input__label {
  font-size: var(--font-size);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-s);
}

.form-input__input {
  background-color: transparent;
  border-radius: var(--border-radius);
  color: var(--text-base);
  border: 1px solid var(--border-subtle);
  padding: var(--spacing-m) var(--spacing-l);
  font-size: var(--font-size);
  outline: none;
  width: 100%;
}

.form-input__input:focus {
  border-color: var(--light-color-60);
}

.form-input__errors {
  color: var(--secondary-color-70);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  padding: var(--spacing) 0;
}

.form-input--error .form-input__input {
  border-bottom-color: var(--secondary-color-70);
}

.form-input[type="color"] .form-input__input {
  padding: 0;
  margin: 0;
  width: 5rem;
  height: 5rem;
}

.form-input[type="color"] .form-input__input:focus {
  border-color: transparent;
}

.form-input[type="color"] ::-webkit-color-swatch-wrapper {
  padding: 0;
}

.form-input[type="color"] ::-webkit-color-swatch {
  border-color: transparent;
  height: 100px;
  width: 100px;
}

.form-input[type="file"] .form-input__input {
  display: none;
}

.form-input[type="file"] {
  border: 1px solid var(--border-subtle);
  background: var(--secondary-surface);
  border-radius: var(--border-radius);
  cursor: pointer;
  color: var(--color);
  display: inline-flex;
  align-items: center;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size);
  font-family: var(--font-family);
  padding: var(--spacing-m);
  justify-content: center;
}

.form-input[type="file"] svg {
  vertical-align: text-bottom;
  margin-right: var(--spacing);
}

</style>
